'use client';
function prefersReducedMotion() {
    return 'undefined' != typeof window && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export { prefersReducedMotion };
